import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

/**
 * Generic centered loading indicator for dashboard pages/sections.
 * Fills the available body height and optionally shows a label.
 */
export default function LoadingState({ message }) {
  return (
    <Stack flex={1} alignItems="center" justifyContent="center" spacing={2} sx={{ py: 6 }}>
      <CircularProgress />
      {message && (
        <Typography color="text.secondary">{message}</Typography>
      )}
    </Stack>
  );
}
